<template>
  <validation-form @on-submit="submitForm">
    <div class="form-input mb-10">
      <div class="md-layout mt-15">
        <div class="md-layout-item md-size-50 md-small-size-100">
          <validation-field :validations="{ required: true }" name="grade">
            <label :for="gradeSelect.name">{{ $t(gradeSelect.label) }}</label>
            <md-select
              :name="gradeSelect.name"
              :id="gradeSelect.id"
              v-model="form.grade_id"
              :multiple="gradeSelect.multiple"
            >
              <md-option
                v-for="option in gradeSelect.options"
                :value="option.id"
                :key="option.id + option.name"
                >{{ option.name }}
              </md-option>
            </md-select>
          </validation-field>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field>
            <label :for="selectType.name">{{ $t(selectType.label) }}</label>
            <md-select
              v-model="form.type"
              :name="selectType.name"
              :id="selectType.name"
              :multiple="selectType.multiple"
            >
              <md-option
                v-for="option in selectType.options"
                :value="option.id"
                :key="option.id + option.name"
                >{{ $t(option.name) }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <validation-field
            :validations="{ required: true, maxLength: 255 }"
            name="calender"
          >
            <label>{{ $t("student.calendar") }}</label>
            <md-input
              :placeholder="$t('student.term_name')"
              v-model.trim="form.calendar"
              required
            ></md-input>
            <span
              style="top:30px"
              class="md-error"
              v-if="serverValidations.calendar"
              >{{ serverValidations.calendar }}</span
            >
          </validation-field>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field>
            <label :for="selectStatus.name">{{ $t(selectStatus.label) }}</label>
            <md-select
              v-model="form.status"
              :name="selectStatus.name"
              :id="selectStatus.name"
              :multiple="selectStatus.multiple"
            >
              <md-option
                v-for="option in selectStatus.options"
                :value="option.id"
                :key="option.id + option.name"
                >{{ $t(option.name) }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <date-picker-custom
            :label="$t('common.start_date')"
            v-model="form.start_date"
          >
            <span class="md-error" v-if="serverValidations.start_date">{{
              serverValidations.start_date
            }}</span>
          </date-picker-custom>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <date-picker-custom
            :label="$t('common.end_date')"
            v-model="form.end_date"
          >
            <span class="md-error" v-if="serverValidations.end_date">{{
              serverValidations.end_date
            }}</span>
          </date-picker-custom>
        </div>
      </div>
    </div>
    <!-- btn -->
    <div class="flex text-right">
      <md-button class="md-raised mr-2" @click="closeModal">
        {{ $t("common.cancel") }}
      </md-button>
      <md-button type="submit" class="md-success">
        {{ dataDetail ? $t("common.update") : $t("common.add") }}
      </md-button>
    </div>
  </validation-form>
</template>
<script>
import { service_paths } from "@/constants/Services";
import cloneDeep from "lodash/cloneDeep";

export default {
  props: ["dataDetail"],
  data() {
    return {
      form: {
        grade_id: "",
        calendar: "",
        type: "primary",
        status: "graduation",
        start_date: "",
        end_date: ""
      },
      isEdit: true,
      serverValidations: "",
      validations: "",
      gradeSelect: {
        label: "common.grade",
        name: "grade",
        value: "",
        type: "select",
        options: []
      },
      selectType: {
        label: "Type",
        name: "type__",
        value: "",
        type: "select",
        options: [
          {
            id: "primary",
            name: "student.primary"
          },
          {
            id: "secondary",
            name: "student.secondary"
          },
          {
            id: "high_school",
            name: "program.high_school"
          }
        ]
      },
      selectStatus: {
        label: "common.status",
        name: "status__",
        value: "",
        type: "select",
        options: [
          {
            id: "graduation",
            name: "student.graduation"
          },
          {
            id: "withdraw",
            name: "student.withdraw"
          },
          {
            id: "dropout",
            name: "student.dropout"
          }
        ]
      }
    };
  },
  created() {
    this.setFormData();
    this.fetchGradeList();
  },
  methods: {
    setFormData() {
      this.form = cloneDeep(this.dataDetail) || this.form;
    },
    submitForm() {
      this.$emit("submit", this.form);
    },
    closeModal() {
      this.$modal.hide("add-enrollment");
      this.$modal.hide("enrollment-detail");
    },
    fetchGradeList() {
      this.$axios.get(service_paths.grades, { limit: 20 }).then(response => {
        this.gradeSelect.options = response.data.data;
      });
    }
  }
};
</script>
